import { useEffect } from 'react';
import { createSignal } from '@funtech-int/rival';

import { clearAutopskipTimer } from '../../ui/skin/next-episode-skip-button-group/hooks/use-is-auto-skip-enabled';

type EpisodeHistoryEntry = {
    contentId: string;
    tvSeriesContentId: string;
    autoskipHappened: boolean;
};

type EpisodeHistory = EpisodeHistoryEntry[];

const episodeHistory = createSignal<EpisodeHistory>([]);

const trackEpisode = (contentId: string, tvSeriesContentId: string) => {
    const history = episodeHistory.get();
    const { length } = history;

    if (contentId === '' || (length && history[length - 1]?.contentId === contentId)) {
        return;
    }

    episodeHistory.set([
        ...history,
        {
            contentId,
            tvSeriesContentId,
            autoskipHappened: false,
        },
    ]);

    if (length && !history[length - 1]?.autoskipHappened) {
        clearAutopskipTimer();
    }
};

export const autoSkipHappened = (contentId: string) => {
    const history = episodeHistory.get();
    const { length } = history;

    const lastHistoryEpisode = history[length - 1];

    if (length && lastHistoryEpisode && lastHistoryEpisode.contentId === contentId) {
        const rest = history.slice(0, -1);
        episodeHistory.set([...rest, { ...lastHistoryEpisode, autoskipHappened: true }]);
    }
};

export const useEpisodeHistory = ({
    contentId,
    tvSeriesContentId,
}: {
    contentId: string;
    tvSeriesContentId: string;
}) => {
    useEffect(() => {
        trackEpisode(contentId, tvSeriesContentId);
    }, [contentId, tvSeriesContentId]);
};
